import React, { createContext, useState, useEffect, useContext } from 'react';
import { authAPI } from '../api/api';

// Создаем контекст авторизации
const AuthContext = createContext(null);

// Провайдер контекста авторизации
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Инициализация состояния авторизации
  useEffect(() => {
    console.log('AuthContext: Инициализация состояния авторизации');
    const storedUser = localStorage.getItem('user');
    const storedToken = localStorage.getItem('token');
    
    if (storedUser && storedToken && storedUser !== 'undefined') {
      try {
        const parsedUser = JSON.parse(storedUser);
        console.log('AuthContext: Пользователь найден в localStorage:', parsedUser.username || parsedUser.first_name);
        setUser(parsedUser);
      } catch (err) {
        console.error('AuthContext: Ошибка при разборе данных пользователя:', err);
        localStorage.removeItem('user');
        localStorage.removeItem('token');
      }
    } else {
      console.log('AuthContext: Пользователь не найден в localStorage');
      // Очищаем localStorage от потенциально поврежденных данных
      localStorage.removeItem('user');
      localStorage.removeItem('token');
    }
    
    setLoading(false);
  }, []);
  
  // Авторизация через Telegram
  const loginWithTelegram = async (telegramData) => {
    console.log('AuthContext: Начинаем авторизацию через Telegram:', telegramData);
    setLoading(true);
    setError(null);
    
    if (!telegramData || !telegramData.id) {
      console.error('AuthContext: Неверные данные авторизации Telegram');
      setError('Неверные данные авторизации');
      setLoading(false);
      return false;
    }
    
    try {
      console.log('AuthContext: Отправляем запрос на авторизацию');
      const response = await authAPI.loginWithTelegram(telegramData);
      console.log('AuthContext: Получен ответ от сервера:', response);
      
      // Если сервер не вернул данные, создаем их на основе данных Telegram
      if (!response.data || (!response.data.token && !response.data.user)) {
        console.warn('AuthContext: Сервер вернул пустой ответ, используем данные от Telegram');
        
        // Создаем фиктивный токен для разработки
        const token = `dev_token_${telegramData.id}_${Date.now()}`;
        
        // Создаем пользователя из данных Telegram
        const user = {
          id: telegramData.id,
          username: telegramData.username || '',
          first_name: telegramData.first_name || 'Пользователь',
          last_name: telegramData.last_name || '',
          photo_url: telegramData.photo_url || ''
        };
        
        // Сохраняем токен и данные пользователя
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        
        console.log('AuthContext: Создан пользователь из данных Telegram:', user);
        setUser(user);
        return true;
      }
      
      // Используем данные от сервера, если они есть
      const { token, user } = response.data;
      
      // Сохраняем токен и данные пользователя
      localStorage.setItem('token', token || '');
      localStorage.setItem('user', JSON.stringify(user || {}));
      
      console.log('AuthContext: Пользователь успешно авторизован:', user?.username || user?.first_name || 'Неизвестный');
      setUser(user || {});
      return true;
    } catch (err) {
      console.error('AuthContext: Ошибка авторизации:', err);
      console.error('AuthContext: Детали ошибки:', err.response?.data || err.message);
      
      // В режиме разработки можно использовать фиктивную авторизацию при ошибках
      if (process.env.NODE_ENV === 'development') {
        console.warn('AuthContext: Используем фиктивные данные для авторизации в режиме разработки');
        
        // Создаем фиктивного пользователя для разработки
        const devUser = {
          id: telegramData.id || 12345678,
          username: telegramData.username || 'dev_user',
          first_name: telegramData.first_name || 'Разработчик',
          last_name: telegramData.last_name || '',
          photo_url: telegramData.photo_url || ''
        };
        
        localStorage.setItem('token', 'dev_token_123');
        localStorage.setItem('user', JSON.stringify(devUser));
        
        setUser(devUser);
        return true;
      }
      
      const errorMessage = err.response?.data?.message || 
                           err.response?.statusText || 
                           err.message || 
                           'Неизвестная ошибка при авторизации';
      
      setError(errorMessage);
      return false;
    } finally {
      setLoading(false);
    }
  };
  
  // Выход из системы
  const logout = () => {
    console.log('AuthContext: Выход из системы');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    window.location.href = '/login';
  };
  
  // Значение контекста
  const contextValue = {
    user,
    loading,
    error,
    isAuthenticated: !!user,
    loginWithTelegram,
    logout,
  };
  
  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};

// Хук для использования контекста авторизации
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth должен использоваться внутри AuthProvider');
  }
  return context;
};

export default AuthContext; 